import { useState, useRef } from "react";
import { ChevronDown } from "lucide-react";
import { useClickOutside } from "../hooks/useClickOutside";

export function Dropdown({ options, selectedOption, onSelect, className = "" }) {
  const [showDropdown, setShowDropdown] = useState(false);

  const dropdownRef = useRef(null);

  useClickOutside(dropdownRef, () => setShowDropdown(false));

  return (
    <div className={`relative bg-white rounded-lg ${className}`} ref={dropdownRef}>
      <button
        type="button"
        onClick={() => setShowDropdown(!showDropdown)}
        className="w-full h-full px-3 py-2 border border-gray-200 rounded-lg text-sm text-gray-700 hover:bg-gray-50 transition-colors flex items-center justify-between gap-2"
      >
        <span className="truncate">{selectedOption}</span>
        <ChevronDown className="w-4 h-4 flex-shrink-0 text-gray-400" />
      </button>

      {showDropdown && (
        <div className="absolute top-full left-0 mt-1 w-full bg-white border border-gray-200 rounded-lg shadow-lg z-50 overflow-hidden">
          {options.map((option) => (
            <button
              key={option}
              type="button"
              onClick={() => {
                onSelect(option);
                setShowDropdown(false);
              }}
              className="w-full px-3 py-2.5 text-left text-sm text-gray-700 hover:bg-gray-50 transition-colors"
            >
              {option}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
